import { Controller } from "@hotwired/stimulus"

// Réinitialise le consentement RGPD (pages légales) — remplace l'onclick
// inline, interdit par la CSP stricte de la surface front
export default class extends Controller {
  reset() {
    localStorage.removeItem("rgpd-consent")
    window.location.reload()
  }
}
